import { FIELD_TYPES } from '../constants';
import { buildSubmitTitle } from './build-submit-title';

export const buildTicketSubmitPayload = (config, values) => {
  const fields = config?.fields ?? [];
  const fileField = fields.find(field => field.type === FIELD_TYPES.FILE);
  const files =
    fileField && Array.isArray(values[fileField.id]) ? values[fileField.id] : [];

  const body = fields.reduce((payload, field) => {
    if (field.type === FIELD_TYPES.FILE) {
      return payload;
    }

    payload[field.id] = values[field.id];

    return payload;
  }, {});

  body.title = buildSubmitTitle(config?.titlePrefix, values.title);

  return { body, files };
};
